import Model from './Model'

// export modelShape from './shape'

export { Model as default }
